<div *ngIf="!loading">
    <metadata-card-view *ngIf="!editMode" fxLayout="column" fxFlex="100" fxLayoutAlign="space-around" [cardMetadata]="cardMetadata" [model]="model" [dense]="dense" [datacontroller]="datacontroller" (toggleEdit)="toggleEditMode()">
    </metadata-card-view>
    <metadata-card-edit *ngIf="editMode" fxLayout="column" fxFlex="100" fxLayoutAlign="space-around" [cardMetadata]="cardMetadata" [model]="model" [dense]="dense" (toggleEdit)="toggleEditMode()" (overrideSave)="onSave()">
    </metadata-card-edit>
</div>
